import axios from "axios";
import { oldBaseUrl } from '../config';

const instance = axios.create({
  baseURL: oldBaseUrl,
  timeout: 0,
  headers: {
    accept: "application/json",
    "content-type": "application/json"
  },
});

export default instance;